<template>
<nav class="main-nav flex ai-c jc-sb">
    <router-link to="/" class="flex ai-c h-100">
        <img class="logo" src="@/assets/img/storsmart-bader-logo.png" width="240" height="80" alt="Storsmart Bader Insurance" />

        <h1 class="title">Audit Letter Program</h1>
    </router-link>

    <div class="as-fe ta-r">
        <strong v-if="user" class="welcome-message d-b mb-3">Welcome, {{ displayName }}!</strong>

        <div class="flex ai-c jc-fe">
            <button
                v-if="!user || (!user.is_monitor && !user.is_admin)"
                class="button small mr-3"
                @click="show_support_modal = true">
                <i class="material-icons">help</i>
                Support
            </button>

            <tag :show="facility && !facility.user.has_changed_password">
                <router-link class="button small" v-show="token" to="/profile">
                    <i class="material-icons">account_circle</i>
                    Profile
                </router-link>
            </tag>

            <router-link class="button small danger ml-3" v-show="token" to="/logout">
                <i class="material-icons">exit_to_app</i>
                Logout
            </router-link>
        </div>
    </div>

    <modal :no-footer="true" v-if="show_support_modal" @close="show_support_modal = false">
        <template slot="header">
            Need Help?
        </template>

        <template slot="content">
            <div class="ta-c pb-2">
                <p>If you have any questions regarding this program, please contact:</p>

                <p>Kim O&rsquo;Neill</p>

                <p>844-410-2733</p>

                <p><a href="mailto:kim.oneill@storable.com">kim.oneill@storable.com</a></p>

                <!-- <hr />

                <p>Need a refresher? Check out our help videos!</p>

                <p><router-link to="/help-videos" class="button small">Help Videos</router-link></p> -->
            </div>
        </template>
    </modal>
</nav>
</template>

<script>
import store from "@/store"

export default {
    name: "main-nav",

    data () {
        return {
            show_support_modal: false
        }
    },

    computed: {
        displayName () {
            if (this.user.real_name) {
                return this.user.real_name
            } else {
                return this.user.username
            }
        },

        facility () {
            return store.state.userFacility.facility
        },

        user () {
            return store.state.user
        },

        token () {
            return store.state.token
        }
    },

    watch: {
        "$route": function (to, from) {
            this.show_support_modal = false
        }
    }
}
</script>

<style>
.main-nav {
    background: #fff;
    border-bottom: 1px solid #b7b7b7;
    padding: 40px;
    transition: height 0.35s ease;
}

.main-nav .logo {
    height: auto;
    margin-right: 30px;
    width: 180px;
}

.main-nav .logo.prime {
    margin-top: -40px;
    margin-bottom: -40px;
}

.main-nav .title {
    font-size: 28px;
    line-height: 1;
    margin: 0;
}

.welcome-message {
    font-weight: 400;
    line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/MainNav.vue